export const NEXT_STEP = 'scenes/PasswordRecovery/next_step'
export const EMAIL_CHANGED = 'scenes/PasswordRecovery/email_changed'



// WEBPACK FOOTER //
// ./src/scenes/PasswordRecovery/constants.js